import React, { useState } from 'react';
import axios from 'axios';
import { ACCESS_KEY } from "../config";

const DeviceBan = () => {
  const [uniqueId, setUniqueId] = useState('');
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  // 🔥 Popup aur Reason ke liye naye states
  const [showBanModal, setShowBanModal] = useState(false);
  const [banReason, setBanReason] = useState('Nudity / Sexual Content');

  // 1. User Search Handler
  const handleSearch = async (e) => {
    e.preventDefault();
    if (!uniqueId) return alert("Please enter a Unique ID");

    setLoading(true);
    setUserData(null);
    setMessage('');

    try {
      const response = await axios.get(`https://admin.butterlive.co.in/management/search-device-user?uniqueId=${uniqueId}&t=${Date.now()}`, {
        headers: { key: ACCESS_KEY }
      });

      if (response.data.status) {
        setUserData(response.data.data);
      } else {
        setMessage(response.data.message || "User not found");
      }
    } catch (error) {
      setMessage(error.response?.data?.message || "User not found");
    } finally {
      setLoading(false);
    }
  };

  // 2. Device Ban Confirm Handler (Modal se call hoga)
  const handleDeviceBanSubmit = async () => {
    if (!userData || !userData.deviceId) return alert("Device ID not found for this user");

    try {
      const response = await axios.post(`https://admin.butterlive.co.in/management/device-ban`, {
        deviceId: userData.deviceId,
        reason: banReason // 🔥 Dropdown se uthaya hua reason backend ko ja raha hai
      }, {
        headers: { key: ACCESS_KEY }
      });

      //alert(response.data.message);
      
      // Local state update taaki bina refresh kiye table me Banned aur selected reason dikhe
      setUserData(prev => ({ 
        ...prev, 
        isDeviceBanned: true, 
        displayReason: banReason 
      }));
      
      setShowBanModal(false); // Popup close
    } catch (error) {
      alert(error.response?.data?.message || "Error banning device");
    }
  };

  // 3. Device Unban Handler
  const handleDeviceUnban = async () => {
    if (!userData || !userData.deviceId) return alert("Device ID not found for this user");
    if (!window.confirm(`Are you sure you want to UNBAN this device?`)) return;

    try {
      const response = await axios.post(`https://admin.butterlive.co.in/management/device-unban`, {
        deviceId: userData.deviceId
      }, {
        headers: { key: ACCESS_KEY }
      });

      alert(response.data.message);
      setUserData(prev => ({ ...prev, isDeviceBanned: false, displayReason: "" }));
    } catch (error) {
      alert(error.response?.data?.message || "Error unbanning device");
    }
  };

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Device Ban Management</h1>
      </div>

      <div className="top-bar">
        <form onSubmit={handleSearch} style={{ display: 'flex', gap: '10px', width: '100%', maxWidth: '500px' }}>
          <input
            type="number"
            placeholder="Search Name / User ID"
            className="search-box"
            value={uniqueId}
            onChange={(e) => setUniqueId(e.target.value)}
            style={{ flex: 1 }}
          />
          <button type="submit" disabled={loading} className="ban-btn ban-btn-active" style={{ height: '40px', padding: '0 25px' }}>
            {loading ? 'Searching...' : 'Search'}
          </button>
        </form>
      </div>

      {message && <p style={{ color: '#e63946', fontWeight: 'bold', padding: '10px 5px' }}>{message}</p>}

      {userData && (
        <div className="table-card">
          <table width="100%" cellPadding="12">
            <thead>
              <tr>
                <th>Photo</th>
                <th>Name</th>
                <th>User ID (Unique)</th>
                <th>Device ID</th>
                <th>Reason</th> {/* 🔥 Naya Column */}
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {userData.image ? (
                    <img src={userData.image} alt="" className="user-avatar" />
                  ) : (
                    "—"
                  )}
                </td>
                <td>{userData.name || 'N/A'}</td>
                <td>{userData.uniqueId}</td>
                <td style={{ color: userData.deviceId ? '#fff' : 'orange', wordBreak: 'break-all' }}>
                  {userData.deviceId || "No Device Linked"}
                </td>
                
                {/* 🔥 Reason Field Display */}
                <td style={{ color: '#9ca3af' }}>
                  {userData.isDeviceBanned ? (userData.displayReason || "Violation of guidelines") : "—"}
                </td>

                <td>
                  <span className={userData.isDeviceBanned ? "status-banned" : "status-active"}>
                    {userData.isDeviceBanned ? "Banned" : "Active"}
                  </span>
                </td>
                <td>
                  {userData.isDeviceBanned ? (
                    <button onClick={handleDeviceUnban} className="ban-btn ban-btn-unban">
                      Unban Device
                    </button>
                  ) : (
                    <button
                      onClick={() => setShowBanModal(true)} // 🔥 Click karte hi custom popup khulega
                      disabled={!userData.deviceId}
                      className="ban-btn ban-btn-active"
                      style={{ background: userData.deviceId ? '#e63946' : '#333', cursor: userData.deviceId ? 'pointer' : 'not-allowed' }}
                    >
                      Ban Device
                    </button>
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}

      {/* 🔥 🔥 DEVICE BAN CUSTOM MODAL POPUP (Matching LiveBan popup style exactly) */}
      {showBanModal && (
        <div className="modal-overlay">
          <div className="modal-box">
            <h3>Select Ban Reason</h3>
            <select
              value={banReason}
              onChange={(e) => setBanReason(e.target.value)}
              style={{
                width: '100%',
                padding: '12px',
                background: '#0f172a',
                color: 'white',
                border: '1px solid #374151',
                borderRadius: '8px',
                fontSize: '14px',
                outline: 'none'
              }}
            >
              <option value="Nudity / Sexual Content">18+ Nudity / Sexual Content</option>
              <option value="Violence / Gore">Violence / Gore</option>
              <option value="Hate Speech / Abuse">Hate Speech / Abuse</option>
              <option value="Using Emulators / Hacks">Using Emulators / Hacks</option>
            </select>

            <br />
            <br />

            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
              <button
                onClick={() => setShowBanModal(false)}
                style={{ background: '#374151', border: '1px solid #4b5563' }}
              >
                Cancel
              </button>

              <button
                className="ban-btn ban-btn-active"
                onClick={handleDeviceBanSubmit}
              >
                Confirm Ban
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DeviceBan;
